import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    change_collect_state(args) {
        return axios.post(`${apiUrl}v2/change_collect_state/`,{ params: args })
    },
    get_collect_state(args) {
        return axios.get(`${apiUrl}v2/get_collect_state/`,{ params: args })
    },
}
